import styled, { css } from 'styled-components'
import colors from '../../../configuration/colors'

const color = defaultColor => {
  return props => {
    // ignore props colors when using dark theme
    if (props.theme.style === 'dark') {
      return defaultColor
    }
    if (props.color) {
      if (props.color.charAt(0) === '#') return props.color
      else return `#${props.color}`
    } else if (props.white) return colors.white
    else if (props.aluminum) return colors.aluminum
    else if (props.silver) return colors.silver
    else if (props.blue) return colors.blue
    else if (props.dove) return colors.dove
    else if (props.slate) return colors.slate
    else if (props.victoria) return colors.victoria
    else if (props.ash) return colors.ash
    else if (props.charcoal4) return colors.charcoal4
    else if (props.fiveam) return colors.fiveam
    else return defaultColor
  }
}

const montserratToggle = props =>
  props.montserrat
    ? css`
        font-family: Montserrat, sans-serif;
      `
    : null

const LatoToggle = props =>
  props.lato
    ? css`
        font-family: 'Lato', sans-serif;
      `
    : null

const coreHeaders = css`
  padding: 0;
  -webkit-margin-before: 0;
  -webkit-margin-after: 0;
`

export const Title = styled.div`
  ${coreHeaders};
  font-family: 'Lato', sans-serif;
  color: ${({ theme }) => theme.captionTitle};
  font-size: 25px;
  font-weight: 500;
  line-height: 1.1;
`

export const Intro5am = styled.div`
  color: ${color(({ theme }) => theme.captionTitle)};
  font-size: 22px;
  font-weight: 300;
  line-height: 1.3;
  font-family: 'Lato', sans-serif;
`

export const Intro = styled.div`
  color: ${color(props => props.theme.intoColor)};
  font-size: 22px;
  font-weight: 300;
  line-height: 1.3;
  font-family: 'Lato', sans-serif;
`

export const Intro2 = styled.div`
  color: ${color(colors.victoria)};
  font-size: 22px;
  font-weight: 400;
  line-height: 1.3;
  font-family: 'Lato', sans-serif;
`

export const Display = styled.div`
  color: ${color(props => props.theme.caption3color)};
  font-size: 30px;
  font-weight: 300;
  line-height: 1.2;
  font-family: 'Lato', sans-serif;
`

export const P1 = styled.div`
  color: ${color(props => props.theme.p1)};
  font-size: 18px;
  font-weight: ${props => (props.bold ? 700 : 500)};
  line-height: 1.3;
  font-family: 'Lato', sans-serif;

  ${montserratToggle}
`

export const P2 = styled.div`
  color: ${color(({ theme }) => theme.p2)};
  font-size: 16px;
  font-weight: 300;
  line-height: 1.3;
  font-family: 'Lato', sans-serif;

  ${montserratToggle}

  ${props =>
    props.regular &&
    css`
      color: ${colors.victoria};
      font-weight: 400;
    `}
`

export const P3 = styled.div`
  color: ${color(({ theme }) => theme.p3)};
  font-size: 15px;
  font-weight: 300;
  line-height: 1.3;
  font-family: 'Lato', sans-serif;
`

export const H1 = styled.div`
  ${coreHeaders};
  font-family: Montserrat, 'Lato', sans-serif;
  color: ${color(({ theme }) => theme.h1)};
  font-size: 30px;
  font-weight: 500;
  line-height: 1.2;

  ${LatoToggle}
`

export const H2 = styled.div`
  ${coreHeaders};
  font-family: Montserrat, 'Lato', sans-serif;
  color: ${color(({ theme }) => theme.h2)};
  font-size: 22px;
  font-weight: ${props => (props.light ? 300 : 600)};
  line-height: 1.2;

  ${LatoToggle}
`

export const H3 = styled.div`
  ${coreHeaders};
  font-family: ${props => (props.lato ? '' : 'Montserrat, ')} 'Lato', sans-serif;
  color: ${color(({ theme }) => theme.h3)};
  font-size: 20px;
  font-weight: ${props => (props.light ? 500 : 600)};
  line-height: 1.1;

  ${LatoToggle}
`
// Seems like Matt's started using new styles for H3
export const H3Alternate = styled.div`
  ${coreHeaders};
  color: ${props => props.theme.blackText};
  font-size: 20px;
  font-weight: 500;
`

export const H4 = styled.div`
  ${coreHeaders};
  color: ${color(({ theme }) => theme.h4)};
  font-size: 18px;
  font-weight: 400;
  line-height: 1.2;
`

export const H5 = styled.div`
  ${coreHeaders};
  color: ${color(props => (props.color ? props.color : props.theme.h5))};
  font-size: 16px;
  font-weight: 400;
  line-height: 1.2;
  font-family: 'Lato', sans-serif;

  ${montserratToggle}

  &.disabled {
    color: ${colors.silver};
  }
`

export const H6 = styled.div`
  ${coreHeaders};
  color: ${color(props => props.theme.h6)};
  font-family: Montserrat, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
`

export const TxtFilterSelect = styled.div`
  color: ${({ theme }) => theme.TxtFilterSelect};
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  text-transform: uppercase;

  &.active {
    color: ${colors.amberLite};
  }
`

export const Hint = styled.div`
  color: ${({ theme }) => theme.hint};
  font-size: 16px;
  font-weight: 300;
  line-height: 1.3;
`

export const Caption1 = styled.div`
  font-family: 'Lato', sans-serif;
  color: ${color(props => props.theme.caption1color)};
  font-size: 13px;
  font-weight: ${props => (props.light ? 300 : 400)};
  line-height: 1.2;
`

export const SidePanelNote = styled.div`
  font-family: 'Lato', sans-serif;
  color: ${color(colors.dove)};
  font-size: 13px;
  line-height: 1.2;
`

export const Tooltip = Caption1

export const Caption2 = styled.div`
  color: ${color(props =>
    props.color ? props.color : props.theme.caption2color
  )};
  font-size: 14px;
  font-weight: 700;
  line-height: 1.1;
  font-family: 'Lato', sans-serif;

  ${montserratToggle}

  ${props =>
    props.dark &&
    css`
      color: ${props => props.theme.caption3color};
    `}
`

export const Caption2White = Caption2

export const Caption3 = styled.div`
  color: ${color(({ theme }) => theme.caption3color)};
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 0.08em;
`

export const Caption3WithIndicator = styled(Caption3)`
  &:after {
    content: ' ';
    box-sizing: border-box;
    height: 10px;
    width: 10px;
    border: 1.5px solid #f5f5f5;
    background-color: #ff5252;
    border-radius: 100%;
    margin-left: 10px;
    position: absolute;
    top: 12px;
  }
`

export const Caption4 = styled.div`
  color: ${color(({ theme }) => theme.caption4color)};
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  font-family: 'Lato', sans-serif;

  ${montserratToggle}
`

export const Caption5 = styled.div`
  color: ${color(({ theme }) => theme.caption5color)};

  font-size: 11px;
  font-weight: ${props => (props.light ? 300 : 400)};
  line-height: 1.2;
  font-family: 'Lato', sans-serif;

  ${montserratToggle}
`

export const Caption6 = styled.div`
  color: ${color(props => props.theme.caption6color)};
  font-size: 11px;
  font-weight: 700;
  line-height: 13px;
  font-family: 'Lato', sans-serif;
`

export const Caption7 = styled.div`
  color: ${color(props => props.theme.caption7color)};
  font-size: 11px;
  font-weight: 500;
  line-height: 1.2;

  ${montserratToggle}
`

const SuccessError = css`
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  font-family: 'Lato', sans-serif;
`

export const ErrorTypography = styled.div`
  ${SuccessError}
  color: ${colors.crimson};
`

export const Success = styled.div`
  ${SuccessError}
  color: ${colors.jade};
`

export const Cobalt = styled.div`
  color: ${colors.white};
  background: ${colors.cobalt};
  font-size: 16px;
  font-weight: 400;
  line-height: 1.2;
`

export const Tab = styled.div`
  color: ${props => (props.selected ? colors.victoria : colors.charcoal4)};
  font-size: 16px;
  font-weight: 500;
  line-height: 1.2;
`

export const DarkIntro = styled.div`
  color: ${colors.ash};
  font-size: 22px;
  font-weight: 300;
  line-height: 1.3;
`

export const WebNav = styled.div`
  color: ${colors.smoke};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
`

export const TooltipBody = styled.div`
  color: ${colors.charcoal4};
  font-size: 14px;
  font-weight: 300;
  line-height: 1.2;
`

const InSelOptStyle = css`
  color: ${props => props.theme.p1};
  background: ${props => props.theme.selectBackground};
  font-size: 16px;
  font-weight: 400;

  &::placeholder {
    color: ${props => props.theme.caption1color};
    font-size: 16px;
    font-weight: 300;
  }
`

export const Input = styled.input`
  ${InSelOptStyle}
`
Input.displayName = 'Input'
export const Select = styled.select`
  ${InSelOptStyle}
`
export const Option = styled.option`
  ${InSelOptStyle}
`

export const CobaltText = styled.div`
  color: ${colors.cobalt};

  &:hover {
    color: #5ec4fa;
  }
`
